import { DatePickerInput, DatePickerInputProps } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import React from 'react';

type DateRangeFilterProps = Omit<DatePickerInputProps<'range'>, 'type'>;

/**
 * Date range picker for filters. Defaults follow the LIA Overview filter,
 * which is the baseline for every menu.
 */
const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  placeholder = 'Start date - End date',
  leftSection = <IconCalendar size={14} />,
  clearable = true,
  size = 'sm',
  w = '100%',
  allowSingleDateInRange = true,
  ...props
}) => (
  <DatePickerInput
    type='range'
    placeholder={placeholder}
    leftSection={leftSection}
    clearable={clearable}
    size={size}
    w={w}
    allowSingleDateInRange={allowSingleDateInRange}
    {...props}
  />
);

export default DateRangeFilter;
